<template>
  <div>
    <h1><span class="fa fa-user" /> {{ participant.first_name }} {{ participant.last_name }}</h1>
    <div class="row">
      <div class="col-md-12">
        <fieldset>
          <legend>{{ $t('myProfile') }}</legend>
          <form ref="profileForm" @submit.prevent="saveProfile">
            <ProfileFields
              ref="profileFields"
              v-model="profileFields"
              :accountId="accountId"
              :config="studyConfig"
            />

            <ul v-if="errors.has(`global`)" class="error-list">
              <li>{{ errors.first(`global`) }}</li>
            </ul>

            <div class="form-group">
              <button :class="{'btn-loading': saving}" type="submit" class="btn btn-primary">
                {{ $t('save') }}
              </button>
            </div>
          </form>
        </fieldset>
      </div>
      <!---
      <div class="col-md-4">
        <fieldset>
          <legend>Actions</legend>
          <ul class="list-unstyled">
            <li class="mb-2">
              <button class="btn btn-default btn-block" type="button">
                Reset My Password
              </button>
            </li>
            <li class="mb-2">
              <router-link :to="{name: 'logout'}" class="btn btn-default btn-block">
                Sign Out
              </router-link>
            </li>
          </ul>
        </fieldset>
      </div>
      --->
    </div>
  </div>
</template>

<script>
  import Vue from "vue";
  import { ToastPlugin } from 'bootstrap-vue';
  import ProfileFields from './enrollment/components/ProfileFields.vue';
  import store from '../store';

  Vue.use(ToastPlugin);

  export default {
    name: "Profile",
    components: {
      ProfileFields,
    },
    beforeRouteEnter: async (to, from, next) => {
      await store.dispatch('LOAD_ACCOUNT', true);
      // TODO move to beforeEach checking meta of isAuthorized
      if (!store.getters.isLoggedIn) {
        next({name: 'login'});
      }
      next();
    },
    data() {
      let data =  {
        saving: false,
        profileFields: {
          first_name: '',
          last_name: '',
          email: '',
          username: '',
          date_of_birth: '',
          cell_phone: '',
          home_phone: '',
          street_address: '',
          street_address2: '',
          city: '',
          state_region: '',
          postal_code: '',
          time_zone: '',
          locale:'',
          external_id: '',
          // notification prefs
          notify_email: false,
          notify_text: false,
          notify_voice: false,
        }
      };

      Object.keys(data.profileFields).forEach((key) => {
        if (this.$store.getters.getParticipant[key]) {
          data.profileFields[key] = this.$store.getters.getParticipant[key];
        }
      });

      return data;
    },
    computed: {
      accountId() {
        return this.$store.state.account.id;
      },
      participant() {
        return this.$store.getters.getParticipant;
      },
      studyConfig() {
        // let config = this.$store.state.study.configuration.enrollment;
        return this.$store.state.study.configuration.profile.profilePortal;
      }
    },
    methods: {
      async saveProfile() {
        this.saving = true;
        const result = await this.$refs.profileFields.validate();

        if (!result) {
          this.saving = false;
          return;
        }

        // get list of visible form field names
        const visibleFields = Array.from(this.$refs.profileForm.elements).map((field) => field.name);

        try{
          await this.$store.dispatch('UPDATE_PROFILE', {profileFields: this.profileFields, visibleFields});
          await this.$store.dispatch('LOAD_ACCOUNT', true);
          this.$bvToast.toast(this.$t('portal.profileSaveSuccess'), {
            title: this.$t('profile'),
            autoHideDelay: 3000,
            variant: 'success'
          })
        } catch (err) {
          if (err.field_errors) {
            this.$refs.profileFields.pushLocalizedErrors(err.field_errors);
          }
          this.$bvToast.toast(this.$t('portal.profileSaveError'), {
            title: this.$t('profile'),
            autoHideDelay: 3000,
            variant: 'danger'
          })
        }

        this.saving = false;
      }
    }
  }
</script>

<style scoped>
  .alert >>> .close {
    margin-left: 6px;
  }
</style>
